module.exports = "$(function(){\n\n    //checkboxes\n    $(':checkbox').radiocheck();\n\n    //tabs\n    $(\".nav-tabs a\").on('click', function (e) {\n        e.preventDefault();\n        $(this).tab(\"show\");\n    });\n\n    $('.portfolio a.over').each(function(){\n\n        overlay = $('<span class=\"overlay\"><span class=\"fui-eye\"></span></span>');\n\n        $(this).append( overlay );\n    });\n\n});"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./assets/original/js/custom.js
// module id = 54
// module chunks = 0 1 3 4 5 6 7 8